import { render } from "./MemberList.vue?vue&type=template&id=08b20d58&scoped=true"
import script from "./MemberList.vue?vue&type=script&lang=js"
export * from "./MemberList.vue?vue&type=script&lang=js"

import "./MemberList.vue?vue&type=style&index=0&id=08b20d58&scoped=true&lang=less"

import exportComponent from "E:\\rt\\AndroidSdk\\qiugxiu\\web-tuiguangzu\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08b20d58"]])

export default __exports__